import React, { Suspense, lazy, useEffect } from 'react';
import { withRouter, Switch, Route } from 'react-router-dom';
import { Loader } from 'semantic-ui-react';
import { ToastContainer, Banner } from './components';
import { connect } from 'react-redux';

import { AppContext } from './AppContext';
import { BANNER_HIDE } from './constants/actionTypes';

import componentLoader from './utils/componentLoader';

// lazy load routes for code splitting
const LayoutDefault = lazy(() =>
  componentLoader(() => import('./views/LayoutDefault/'))
);
const Account = lazy(() =>
  componentLoader(() => import('./views/Account/Account'))
);
const Login = lazy(() => componentLoader(() => import('./views/Login/Login')));

const mapStateToProps = state => ({
  bannerIsVisible: state.banner.bannerIsVisible,
});

const mapDispatchToProps = dispatch => ({
  hideBanner: () => {
    dispatch({ type: BANNER_HIDE });
  },
});

function App({
  location,
  redirectTo,
  hideBanner,
  onRedirect,
  bannerIsVisible,
}) {
  const { pathname } = location;

  useEffect(() => {
    // we navigated
    hideBanner();
  }, [pathname, hideBanner]);

  useEffect(() => {
    if (redirectTo) {
      onRedirect(redirectTo);
    }
  }, [redirectTo, onRedirect]);

  return (
    <div>
      {/*
        <Banner
          isVisible={true}
          message={
            'Due to a current outage with Amazon Web Services, ticket-related features may not work as expected. Please email or call if you have an urgent need.'
          }
          type="warning"
        />
            */}
      <Banner isVisible={bannerIsVisible} />
      <ToastContainer />
      <Suspense fallback={<Loader />}>
        <Switch>
          <Route path="/timeout" component={Login} />
          <Route path="/login" component={Login} />
          <Route path="/login-standard" component={Login} />
          <Route path="/login-error" component={Login} />
          <Route path="/login-finalize" component={Login} />
          <Route path="/account" component={Account} />
          <Route path="*" component={LayoutDefault} />
        </Switch>
      </Suspense>
    </div>
  );
}

const WrappedApp = props => (
  <AppContext.Consumer>
    {({ userProfile, setProfile, redirectThenClear, redirectTo }) => (
      <App
        {...props}
        userProfile={userProfile}
        setProfile={setProfile}
        onRedirect={redirectThenClear}
        redirectTo={redirectTo}
      />
    )}
  </AppContext.Consumer>
);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(WrappedApp));
